import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Profit from './Profit/Profit';
import Sale from './Sale/Sale';
import lang from './lang';
import './Dashboard.css';

class Dashboard extends Component {
    state = {
        totalProducts: 0,
        startDate: moment().weekday(1).hour(0).minute(0).second(0).valueOf(),
        endDate: new Date().getTime(),
        calendar: false,
        period: 'current'
    }

    sortByTime = (e) => {
        const { name } = e.target;

        ["current", "month", "quater", "semiannual", "annual"].forEach(btn => {
            e.target.classList.add('active')
            if (name === btn) {
                e.target.classList.add('active')
                this.setState({ period: name })
            } else {
                this[btn + "Ref"].classList.remove('active')
            }
        });
    }


    render() {
        const {
            week,
            month,
            year,
        } = lang[this.props.user.lang || "en"];

        return (
            <div id="dashboard-page">
                <div className="row justify-content-center">
                    <div className="btn-group btn-group-sm" role="group" aria-label="Basic example">
                        <button
                            onClick={(e) => this.sortByTime(e)}
                            name="current"
                            ref={ref => this.currentRef = ref}
                            className="btn btn-outline-secondary active"
                        >{week}</button>
                        <button
                            onClick={(e) => this.sortByTime(e)}
                            name="month"
                            ref={ref => this.monthRef = ref}
                            className="btn btn-outline-secondary"
                        >{month}</button>
                        <button
                            onClick={(e) => this.sortByTime(e)}
                            name="quater"
                            ref={ref => this.quaterRef = ref}
                            className="btn btn-outline-secondary"
                        >3 {month}</button>
                        <button
                            onClick={(e) => this.sortByTime(e)}
                            name="semiannual"
                            ref={ref => this.semiannualRef = ref}
                            className="btn btn-outline-secondary"
                        >6 {month}</button>
                        <button
                            onClick={(e) => this.sortByTime(e)}
                            name="annual"
                            ref={ref => this.annualRef = ref}
                            className="btn btn-outline-secondary"
                        >1 {year}</button>
                    </div>
                </div>


                <Profit
                    style={{ marginTop: '50px' }}
                    data={this.props.sales}
                    period={this.state.period}
                    currency={this.props.user.currency}
                    expenses={this.props.expenses}
                    lang={this.props.user.lang}
                />
                <Sale
                    style={{ marginTop: '50px' }}
                    data={this.props.sales}
                    products={this.props.products}
                    period={this.state.period}
                    currency={this.props.user.currency}
                    expenses={this.props.expenses}
                    lang={this.props.user.lang}
                />
            </div >

        );
    }
}

const mapStateToProps = state => {
    return {
        expenses: state.expenses.expenses,
        products: state.products.products,
        sales: state.sales.sales,
        user: state.user
    }
}

export default connect(mapStateToProps)(Dashboard);